import type {Job,WebDelivery} from '../../lib/types';

export function articleDeliveryLabel(delivery?:WebDelivery){
 if(!delivery)return undefined;
 if(delivery.state==='verified')return delivery.action==='unpublish'?'Afpubliceret':undefined;
 if(delivery.state==='failed')return delivery.action==='unpublish'?'Afpublicering ikke bekræftet':'Udgivelse ikke bekræftet';
 if(delivery.state==='superseded')return 'Erstattet af nyere udgivelse';
 if(delivery.action==='unpublish')return 'Fjerner fra hjemmesiden';
 return 'Opdaterer hjemmesiden';
}
export function waitingForWebsite(delivery?:WebDelivery){
 return !!delivery&&!['verified','failed','superseded'].includes(delivery.state);
}
export function isHistoricalArticlePublication(job:Job,currentDelivery?:WebDelivery){
 return job.target.kind==='article'&&['succeeded','cancelled'].includes(job.status)&&
  currentDelivery?.generation!==undefined&&(job.webDelivery?.generation===undefined||job.webDelivery.generation<currentDelivery.generation);
}
export function shouldPollPublication(job:Job){
 return ['queued','scheduled','claimed','sending','unknown'].includes(job.status)||
  (job.target.kind==='article'&&job.status==='succeeded'&&(!job.webDelivery||waitingForWebsite(job.webDelivery)));
}
export function mergeWebDelivery(previous?:WebDelivery,incoming?:WebDelivery){
 if(!incoming)return previous;
 if(!previous)return incoming;
 // A historical publication without an outbox generation cannot replace tracked delivery.
 if(previous.generation!==undefined&&incoming.generation===undefined)return previous;
 if(previous.generation===undefined&&incoming.generation!==undefined)return incoming;
 if(previous.generation!==undefined&&incoming.generation!==undefined&&previous.generation!==incoming.generation)return previous.generation>incoming.generation?previous:incoming;
 if(previous.checkedAt&&incoming.checkedAt)return Date.parse(previous.checkedAt)>Date.parse(incoming.checkedAt)?previous:incoming;
 // Older servers have no observation time. Never regress a confirmed release to an unconfirmed observation.
 if(previous.state==='verified'&&incoming.releaseId===previous.releaseId)return previous;
 return incoming;
}
export function mergePublicationJob(previous:Job|undefined,incoming:Job):Job{
 if(!previous||incoming.version>previous.version)return incoming;
 if(previous.version>incoming.version)return previous;
 const webDelivery=mergeWebDelivery(previous.webDelivery,incoming.webDelivery);
 if(webDelivery&&webDelivery===previous.webDelivery&&webDelivery!==incoming.webDelivery)return previous;
 return {...previous,...incoming,...(webDelivery?{webDelivery}:{})};
}
